'use strict';

import {fnErrorMsg, pjaxRedirect, printResponse} from "../../jquery-functions-library";
import {element_exists} from "../../functions";

export var fnDashBustTableCache = function () {

    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}});

    var btn = '#bust_cache_btn';

    if (!element_exists(btn)) return false;

    $(document).off('click', btn).on('click', btn, function (e) {
        e.preventDefault();

        var url = $(this).attr('data-href');
        console.log(url);
        $.ajax({
            url: url,
            success: function (response) {
                console.log(response);
                printResponse(response);
                pjaxRedirect(window.location.href);
                // $('#datatable-db-v2-all').DataTable().ajax.reload();
            },
            error: fnErrorMsg
        });
    })
};